define('CustomerCategory.Facets.Browse.View', [
    'Facets.Browse.View',
    'CustomerCategory.Utils',
    'Profile.Model',
    'jQuery',
    'underscore'
], function CustomerCategoryFacetsBrowseView(
    FacetsBrowseView,
    CustomerCategoryUtils,
    ProfileModelModule,
    jQuery,
    _
) {
    'use strict';

    var ProfileModel = ProfileModelModule.ProfileModel || ProfileModelModule;
    var originalBeforeShowContent = FacetsBrowseView.prototype.beforeShowContent;

    _.extend(FacetsBrowseView.prototype, {
        beforeShowContent: function beforeShowContent() {
            var self = this;
            var promise = jQuery.Deferred();
            var categoryModel = this.model.get('category');
            var nativePromise = originalBeforeShowContent.apply(this, arguments);

            nativePromise
                .then(function() {
                    var profile = ProfileModel.getInstance();
                    var categoriesGroup = SC.ENVIRONMENT.published.commerceCategoriesGroup || [];
                    var profileCustomFields = profile && profile.get('customfields');
                    var webCategory = profileCustomFields && profileCustomFields.length && _.findWhere(profileCustomFields, { name: 'custentity6' });
                    var customerCategory = (webCategory && webCategory.value) || '1';
                    var categoryGroup;

                    categoryGroup = categoryModel && categoriesGroup[categoryModel.get('internalid')];
                    if (categoryModel && !CustomerCategoryUtils.isCategoryVisible(
                        categoryGroup,
                        customerCategory,
                        SC.ENVIRONMENT.currentHostString,
                        !!(categoriesGroup && categoriesGroup.length)
                    )) {
                        self.application.getLayout().notFound();
                        promise.reject();
                    } else {
                        promise.resolve();
                    }
                })
                .fail(function() {
                    promise.reject();
                });

            return promise;
        }
    });
});
